const en = {
    loginEmail: "E-mail or phone",
    loginError: "Incorrect e-mail(username) or password",
    loginForgotPassword: "Forgot password",
    loginPassword: "Password",
    loginCreateAccount: "Create account",
    loginLoginIn: "Log in"
};
export default en;
